__webpack_require__.p = "/portal/_next/";